export default "__VITE_ASSET__nfNWp49$__"